exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog[data-v-ebfa2854]{min-width:320px;padding:4px}.buttons[data-v-ebfa2854]{margin-top:16px;text-align:right}.form[data-v-ebfa2854]{margin-bottom:20px}", ""]);

// exports
